import Products from '@/pages/home/components/Products';

export default function Productos() {
  return (
    <main className="min-h-screen bg-background-50">
      <Products />
    </main>
  );
}